// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eWx-","comment":"styles_comment__GV6XL"};